






















































import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";
import CashbackDetailInfo from "@/views/app/CashbackDetailInfo.vue";
import BlurredTenant from '@/components/BlurredTenant.vue';
import { encode } from "@common/util/base64Util";

export default Vue.extend({
  components: {CashbackDetailInfo, BlurredTenant},
  data() {
    const that = this;
    return {
      showBlur: userManager.checkRole(["cpoAdmin", "cpoMonitor"], true) && !!userManager.getUserInfo().tenant?.setting?.expDate && userManager.getUserInfo().tenant.setting.expDate < new Date().getTime(),
      userProfile: null as any,
      tableOptions: {
        attrs: {
          "item-key": "_id",
          "sort-by": "date",
          "sort-desc": true,
          "show-expand": true,
        },
        content: {
          name: "Revenue",
          urlEnabled: true,
          search: {
            ext: {
              hidden: true,
            },
          },
          filters: {
            filters: {
              status: {
                type: "select",
                attrs: {
                  label: "Status",
                  items: [
                    { text: "Paid", value: 1 },
                    { text: "Unpaid", value: 0 },
                  ],
                },
                rules: {
                  equal_to: {},
                },
              },
              point: {
                type: "number",
                attrs: {
                  label: "Total",
                },
                rules: {
                  greater_than: {
                    attrs: {
                      label: "Total (min)",
                      xOptions: {
                        content: {
                          resultFilter: () => 0,
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          displayFields: {
            date: {
              text: "Date",
              options: {
                transform: (value) => {
                  if (value == null) { return ''; }
                  try {
                    const date = new Date(value);
                    if (isNaN(date.getTime())) { return ''; }
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const day = String(date.getDate()).padStart(2, '0');
                    return `${year}-${month}-${day}`;
                  } catch (error) {
                    console.error('Date transform error:', error);
                    return '';
                  }
                },
                to: (value, row) => {
                  if (value == null || row == null) { return '#'; }

                  console.log('value', value);

                  try {
                    const clickedDate = new Date(value);
                    if (isNaN(clickedDate.getTime())) { return '#'; }
                    const gmtStartDate = Date.UTC(clickedDate.getUTCFullYear(), clickedDate.getUTCMonth(), clickedDate.getUTCDate(), 0, 0, 0, 0);

                    // Calculate stopTime values
                    const stopTimeFrom = gmtStartDate - 7* 3600* 1000;
                    const stopTimeTo = gmtStartDate + (24 * 60 * 60 * 1000) - 7* 3600* 1000;
                    const cpoGroupId = row.cpoGroupId || that.$route.params.id || that.userProfile?.cpoGroupId;

                    const filtersChargingSessions = {
                      "customPerPage": 0,
                      "dataOptions": {
                        "groupBy": [],
                        "groupDesc": [],
                        "itemsPerPage": 50,
                        "multiSort": false,
                        "mustSort": false,
                        "page": 1,
                        "sortBy": [
                          "startTime"
                        ],
                        "sortDesc": [
                          false
                        ]
                      },
                      "filters": []
                    };

                    // Build URL with all filters as parameters instead of in table_options
                    const ocpiModeMeta = that.$route?.meta?.ocpiMode;
                    let urlParams = `table_options=${encode(JSON.stringify(filtersChargingSessions))}`;

                    // Add all filter parameters to URL
                    urlParams += `&cpoGroupId=${cpoGroupId}`;
                    urlParams += `&stopTimeFrom=${stopTimeFrom}`;
                    urlParams += `&stopTimeTo=${stopTimeTo}`;

                    // Add OCPI mode to URL parameters
                    if (ocpiModeMeta === "roaming_in") {
                      urlParams += `&ocpi=true&ocpiData=null`;
                    } else if (ocpiModeMeta === "roaming_out") {
                      urlParams += `&ocpi=true&ocpiData=not_null`;
                    } else {
                      // Local cashback mode
                      urlParams += `&ocpi=false`;
                    }

                    return `/app/Sessions?${urlParams}`;
                  } catch (error) {
                    console.error('Error in to function:', error);
                    return '#';
                  }
                },
              },
            },
            powerConsumption: {
              text: "Power Consumption (kWh)",
              sortable: true,
            },
            electricityTariff: {
              text: "Electricity Tariff",
              sortable: true,
            },
            powerCost: {
              text: "Power Cost (VND)",
              sortable: true,
            },
            point: {
              text: "Revenue (VND)",
              sortable: true,
            },
            netRevenue: {
              text: "Net Revenue (VND)",
              sortable: true,
            },
            ratio: {
              text: "Ratio",
              sortable: true,
            },
            partnerRevenue: {
              text: "Partner Revenue (VND)",
              sortable: true,
            },
            status: {
              text: "Status",
            },
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              // Get ID from route params, or fetch from profile API
              let id = that.$route.params.id;
              if (!id) {
                // Fetch user profile if not already loaded
                if (!that.userProfile) {
                  that.userProfile = await coreApiClient.callRaw("auth", "getProfile");
                }
                id = that.userProfile?.cpoGroupId;
              }
              return await that.getAll(id, options);
            },
          },
        },
      },
    };
  },
  methods: {
    async getAll(id, options) {
      const payload = JSON.parse(options.payload || "{}")
      if (!payload.filters) {
        payload.filters = [];
      }

      // For cpoGroup, filter by cpoGroupId
      payload.filters = [
        ...payload.filters,
        {
          key: "cpoGroupId",
          operator: "equal_to",
          value: id,
        },
      ];

      options.payload = JSON.stringify(payload);

      // For local cashback (default route), use 'local' as ocpiMode
      // For roaming routes, use the meta ocpiMode
      let ocpiModeMeta = this.$route?.meta?.ocpiMode as string | undefined;
      if (!ocpiModeMeta) {
        ocpiModeMeta = 'local'; // Default to 'local' for the main cashback route
      }
      console.log('CashbackDetailGroup getAll - ocpiMode:', ocpiModeMeta, 'route:', this.$route?.path);

      const apiOptions = { ...(options || {}) };
      // Always add ocpiMode parameter
      apiOptions.ocpiMode = ocpiModeMeta;
      console.log('CashbackDetailGroup getAll - apiOptions with ocpiMode:', apiOptions);

      const { items, count } = await coreApiClient.call("cashBacks", "findAllByGroup", apiOptions);
      return [items, count];
    },
  },
  created() {
  },
});

